import HoldCard from './hold-card';

export default HoldCard;
